import { createFileRoute } from "@tanstack/react-router";
import PledgeAdmin from "@/components/Pledges/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const { id } = useParams<{ id: string }>();
  return <PledgeAdmin pledgeId={id} />;
}

export const Route = createFileRoute("/_authenticated/pledges/$id/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
